Directives.FeedItemDirective =  function FeedItemDirective(){

    // @ngInject
    function FeedItemDirectiveControllerFunc($scope, $injector, Enums, PopupMessageService, UsersManager, AnalyticsService, Enums){

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'FeedItemDirectiveController';
        this.ItemTypes = Enums.FeedItemTypes;
        this.PopupMessageService = PopupMessageService;
        this.AnalyticsService = AnalyticsService;
        this.Enums = Enums;
        this.currUser = UsersManager.getCurrUser();
        if (!this.feedUsers[this.currUserId]) { //add current user to feed users for correct view in case curr user comments for the first time
            //hacky solution until we move to fetching updated users in feed, properly.
            this.feedUsers[this.currUserId] = this.currUser;
        }

        this._allowComments = (this.allowComments === "true");
        if (this._allowComments) {
            this.newComment = "";
            this.submittingComment = false;
            this.toggleAllComments(false);
        }

        switch (this.item.type_cd) {
            case this.ItemTypes.workspace_email:
            case this.ItemTypes.workspace_file_email:
            case this.ItemTypes.reschedule_project_email:
            case this.ItemTypes.workspace_message:
            case this.ItemTypes.feed_message:
            case this.ItemTypes.file_comment_message:
                this.hasSender = true;
                if (this.item.data && this.item.data.sender_user_id) {
                    this.senderIsMe = (this.currUserId ===  this.item.data.sender_user_id);
                    this.senderUser = this.feedUsers[this.item.data.sender_user_id];
                    if (!this.senderUser) {
                        this.senderUser = this.deletedUsers[this.item.data.sender_user_id];
                        if (!this.senderUser) {
                            console.log("Missing user for avatar: " + this.item.data.sender_user_id);
                        }
                    }
                    this.sentDate = this.item.data.sent_on;
                    this.fileSubject = this.item.data.subject;
                }
                break;
            case this.ItemTypes.activity:
            case this.ItemTypes.generic_message:
                this.hasSender = false;
                break;
        }

        this.isUserActivated = this.currUser.isActivated();

    }

    var FeedItemDirectiveController = Class(Controllers.BaseController, {
        constructor: FeedItemDirectiveControllerFunc,

        commentKeyPress: function commentKeyPress(event) {
            if ((event.keyCode === 13 || event.which === 13) && !event.shiftKey) {
                event.preventDefault();
            }
        },

        commentKeyUp: function commentKeyUp(event, comment) {
            if (event.keyCode == 13 ) { //ENTER was pressed
                if (event.shiftKey) {
                    this.AnalyticsService.track(this, "press shift enter in comment", this.analyticsProperties());
                    return;
                } else {
                    if (comment) { //editing existing comment
                        this.AnalyticsService.track(this, "press enter: edit comment", this.analyticsProperties());
                        this.updateComment(comment);
                    }
                    else {
                        this.AnalyticsService.track(this, "press enter: send comment", this.analyticsProperties());
                        this.submitNewComment();
                    }
                }
            }
            if (event.keyCode == 27)  { //ESC was pressed
                if (comment) {
                    comment.body = comment._body_backup;
                    comment.allowEdit = false;
                }
            }
        },

        commentClick: function commentClick(event, comment) {
            if (comment) { //editing existing comment
                this.updateComment(comment);
            }
            else {
                this.submitNewComment();
            }

        },

        collapseEditMode: function collapseEditMode(comment) {
            comment.allowEdit = false;
        },

        toggleCommentActions: function toggleCommentActions(comment) {
            comment.showCommentActions = !comment.showCommentActions;
        },

        submitNewComment: function submitNewComment() {
            if (!/^\s*$/.test(this.newComment)) { //comment not empty
                this.submittingComment = true;
                this.itemCallbacks.submitComment(this.item, this.newComment).then(
                    function success() {
                        this.newComment = "";
                        this.submittingComment = false;
                    }.bind(this),
                    function error() {
                        this.submittingComment = false;
                    }.bind(this)
                );
            }
        },

        deleteComment: function deleteComment(comment) {
            this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning,
                'COMMON_FEED_COMPONENTS.COMMENTS._CONFIRM_DELETE_MESSAGE_',
                function() {
                    this.itemCallbacks.deleteComment(this.item, comment).then(
                        function success() {
                            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.delete_feed_item_comment, this.analyticsProperties());
                        }.bind(this),
                        function error() {
                            this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.delete_feed_item_comment, this.analyticsProperties());
                        }.bind(this)
                    )
                }.bind(this));
        },

        allowEditComment: function allowEditComment(comment) {
            comment.showCommentActions = false;
            comment.allowEdit = true;
            comment._body_backup = comment.body;
        },

        updateComment: function updateComment(comment) {
            comment.allowEdit = false;
            if (/^\s*$/.test(comment.body)) { //comment is empty
                comment.body = comment._body_backup;
                this.deleteComment(comment);
            } else {
                if (comment.body === comment._body_backup) {
                    return;
                }
                this.itemCallbacks.updateComment(this.item, comment).then(
                    function success(resp) {
                        this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.update_feed_item_comment, this.analyticsProperties());
                    }.bind(this),
                    function error() {
                        comment.body = comment._body_backup;
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.update_feed_item_comment, this.analyticsProperties());
                    }.bind(this)
                )
            }
        },

        toggleAllComments: function toggleAllComments(showComments) {
            if (typeof showComments === 'boolean') {
                this.showAllComments = showComments;
            } else {
                this.showAllComments = !this.showAllComments;
            }
            if (this.showAllComments) {
                this.commentsLimit = 'Infinity'; //no limit
                this.showCommentsLabel = "COMMON_FEED_COMPONENTS.COMMENTS._HIDE_COMMENTS_";
            } else {
                this.commentsLimit = -1;
                this.showCommentsLabel = "COMMON_FEED_COMPONENTS.COMMENTS._SHOW_COMMENTS_";
            }
        },

        analyticsProperties: function analyticsProperties() {
            var ret = {
                item_id: this.item._id,
                item_type: this.item.type
            };
            if (this.senderUser) {
                ret.item_creator_id = this.senderUser._id;
            }
            return ret;
        },

        shouldShowDelete: function shouldShowDelete() {
            var allowedTypes = [this.ItemTypes.workspace_file_email, this.ItemTypes.workspace_email, this.ItemTypes.workspace_message, this.ItemTypes.feed_message];
            return this.currUser.isAdminLogin() && allowedTypes.indexOf(this.item.type_cd) !== -1;
        },

        onClickDelete: function onClickDelete() {
            this.PopupMessageService.showConfirmPromise(
                this.PopupMessageService.severityTypes.warning,
                'Are you sure you want to delete this feed message?').then(function yes() {
                this.item.deleteItem().catch(function fail(e) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, e.data.error_message);
                }.bind(this));
            }.bind(this));
        },

        deleteScheduledMessage: function deleteScheduledMessage() {
            this.PopupMessageService.showConfirmPromise(
                this.PopupMessageService.severityTypes.warning,
                'Are you sure you want to cancel this scheduled email?').then(function yes() {
                    this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.delete_scheduled_send_feed_item);
                    this.item.deleteItem().catch(function fail(e) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, e.data.error_message);
                }.bind(this));
            }.bind(this));
        },

        isSessionFeedItem: function isSessionFeedItem() {
            var sessionTypes = ['meeting_scheduled', 'meeting_canceled', 'meeting_updated'];
            return sessionTypes.indexOf(this.item.data.action_type) !== -1;
        },

        isGiftCardFeedItem: function isGiftCardFeedItem() {
            var giftCardTypes = [this.Enums.giftCardStates.promotionPurchased];
            return giftCardTypes.indexOf(this.item.data.action_type) !== -1;
        }
    });

    return {
        scope:{
            item: '=item',
            eventId: '@eventId',
            feedUsers: '=feedUsers',
            deletedUsers: '=deletedUsers',
            currUserId: '@currUserId',
            itemCallbacks: '=itemCallbacks',
            allowComments: '@allowComments',
            feedOwnerCompanyId: '=?'
        },
        templateUrl : 'angular/app/modules/core/features/feed/feed_item_template.html',
        controller : FeedItemDirectiveController,
        controllerAs : 'feedItemVm',
        bindToController : true
    };
};